import React from 'react'
import ContactForm from './ContactForm'
import ContactMap from './ContactMap'
import ContactForm2 from './ContactForm2'
import Locations from './Locations'

const index = () => {
  return (
    <div>
      {/* <ContactForm2/> */}
      <Locations/>
      <ContactMap/>
    </div>
  )
}

export default index
